import React from 'react';
type Brand = {
  name: string;
  src?: string;
  wordmark?: 'aspen' | 'multi-radiance' | 'awusa' | 'lumanova' | 'hivamat';
};
const BRANDS: Brand[] = [{
  name: 'Aspen Laser',
  wordmark: 'aspen'
}, {
  name: 'Multi Radiance Medical',
  wordmark: 'multi-radiance'
}, {
  name: 'AWUSA',
  wordmark: 'awusa'
}, {
  name: 'LumaNova',
  wordmark: 'lumanova'
}, {
  name: 'TheraLight',
  src: 'https://cdn.magicpatterns.com/uploads/vttP1Sb7gikoGaFWY35ZNt/theralight-logo-tight.png'
}, {
  name: 'ThermoVision',
  src: 'https://cdn.magicpatterns.com/uploads/pwi9F6MQ1aEKhfXdZzRCNm/thermovision-myovision-logo.png'
}, {
  name: 'WellVu',
  src: 'https://cdn.magicpatterns.com/uploads/qMimGwm5vM6HRxKcW7oosi/wellvu-logo.png'
}, {
  name: 'Hivamat',
  wordmark: 'hivamat'
}, {
  name: 'Endopuls',
  src: 'https://cdn.magicpatterns.com/uploads/2VZTmXjs9iTkUtkfftmxFG/endopuls-enraf-logo.png'
}];
function BrandMark({
  brand
}: {
  brand: Brand;
}) {
  if (brand.src) {
    return <img src={brand.src} alt={`${brand.name} logo`} className="manufacturer-strip__logo block h-7 w-full max-w-[104px] object-contain" data-id="element-219" data-mp="2f7bi8sb516cz" />;
  }
  switch (brand.wordmark) {
    case 'aspen':
      return <span className="flex w-full max-w-full flex-col items-center justify-center px-2 text-center leading-none" data-id="element-220" data-mp="2o66q08ttyoie">
          <span className="text-[14px] font-extrabold tracking-[0.02em] text-teal" data-id="element-221" data-mp="2t488osncgltc">ASPEN</span>
          <span className="mt-1 text-[10px] font-semibold tracking-[0.08em] text-navy/75" data-id="element-222" data-mp="2y3l627budba6">LASER</span>
        </span>;
    case 'multi-radiance':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-223" data-mp="36zank5a65lia">
          <span className="flex h-4 w-4 items-center justify-center rounded-full border border-teal/60" data-id="element-224" data-mp="3bxc68p3onit8">
            <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-225" data-mp="3gx8bero49gad" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-226" data-mp="3luqn2ptiq9m2">
            <span className="text-[12px] font-bold tracking-[-0.04em]" data-id="element-227" data-mp="3lt5rcwvgwkmm">Multi Radiance</span>
            <span className="mt-0.5 text-[7px] font-semibold uppercase tracking-[0.14em] text-teal" data-id="element-228" data-mp="2w7e3rzcpq0c6">
              Medical
            </span>
          </span>
        </span>;
    case 'awusa':
      return <span className="flex flex-col items-center leading-none text-navy" data-id="element-229" data-mp="35yqwsua8ywjs">
          <span className="text-[17px] font-extrabold tracking-[0.04em]" data-id="element-230" data-mp="314mlxzxv24df">AWUSA</span>
          <span className="mt-1 h-0.5 w-10 rounded-full bg-teal" data-id="element-231" data-mp="3ewayg4c0uuux" />
        </span>;
    case 'lumanova':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-232" data-mp="3a0lwxvgfz3vz">
          <span className="h-3 w-3 rounded-full border-[3px] border-teal" data-id="element-233" data-mp="3ova032yddq8f" />
          <span className="text-[17px] font-bold tracking-[-0.05em]" data-id="element-234" data-mp="3jxqlu31o9dgh">LumaNova</span>
        </span>;
    case 'hivamat':
      return <span className="flex flex-col items-center leading-none text-navy" data-id="element-235" data-mp="1ujv80fhvzepi">
          <span className="text-[17px] font-extrabold tracking-[0.08em]" data-id="element-236" data-mp="1pk8tm2qbnsf4">HIVAMAT</span>
          <span className="mt-1 text-[7px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-237" data-mp="51yc0ekh6afj">
            Deep Oscillation
          </span>
        </span>;
    default:
      return null;
  }
}
export function ManufacturerStrip() {
  return <section className="manufacturer-strip w-full max-w-full overflow-x-hidden border-y border-slate-200 bg-slate-50/90" data-id="element-238" data-mp="3redmhtbjwqlq">
      <div className="manufacturer-strip__inner mx-auto w-full max-w-7xl box-border overflow-x-hidden px-5 py-7 sm:px-8" data-id="element-239" data-mp="3ifs01n2ykrfo">
        <p className="manufacturer-strip__heading mx-auto max-w-full whitespace-normal break-words px-2 text-center text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-charcoal/55" data-id="element-240" data-mp="3mi6ezw3ib71o">
          <span className="manufacturer-strip__heading-mobile" data-id="element-241" data-mp="3dhi06z6ah2nq">
            TRUSTED MODALITY BRANDS
          </span>
          <span className="manufacturer-strip__heading-desktop" data-id="element-242" data-mp="16qijm5455mkz">
            CURATED TECHNOLOGIES FROM TRUSTED MODALITY BRANDS
          </span>
        </p>
        <ul className="manufacturer-strip__chips mx-auto mt-4 grid w-full max-w-[300px] grid-cols-1 gap-2.5 sm:max-w-7xl sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 lg:gap-2" aria-label="Trusted modality brands" data-id="element-243" data-mp="37sqh98iywf4k">
          {BRANDS.map(brand => <li key={brand.name} className={`flex h-14 min-w-0 w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-3 shadow-[0_3px_10px_-7px_rgba(26,27,75,0.34)] ${brand.wordmark === 'aspen' ? 'overflow-visible' : 'overflow-hidden'}`} data-id="element-244" data-mp="2tsfqs6lkl2jx">
              <BrandMark brand={brand} data-id="element-245" data-mp="2f39ryjqn9eck" />
            </li>)}
        </ul>
      </div>
    </section>;
}